import React, { useEffect } from 'react';
import Seo from './Seo';
import { assetUrl } from '../utils/assets';

const SEO = {
  title: 'Developments | Tavernix',
  description: 'Products Tavernix designs, builds and runs: Pixionary and Cash to Class A–Z.',
  canonical: 'https://tavernix.io/developments',
};

/* Products we build and run ourselves. Customer-facing copy: say what it does
   for people, keep the stack short, and never surface internal vendors. */
const projects = [
  {
    name: 'Pixionary',
    kind: 'AI creation studio',
    image: 'dev-pixionary-hero',
    alt: 'The Pixionary home page: a glass flower behind the headline Imagine it. Type it. See it., the Image, Video, Voice and Assets buttons and a prompt box',
    desc: 'Images, video and voiceovers from a single prompt, using the leading models (Kling, Veo, Seedance, Gemini and GPT Image) and Sapphire, our own voice engine. Pay as you go, with credits that never expire.',
    link: { href: 'https://pixionary.net', label: 'Visit pixionary.net' },
  },
  {
    name: 'Cash to Class A–Z',
    kind: 'Money basics for kids',
    image: 'dev-cashclass',
    alt: 'Cash Class Academy title card: Money Made Simple',
    desc: 'A kid-friendly finance app that teaches saving, spending and budgeting through short video lessons and mini-games like Asset Sorter, Budget Builder and Coin Run. Videos play in a locked-down player: no comments, no suggestions, nowhere to wander off.',
    link: { href: 'https://cashclass.org', label: 'Visit cashclass.org' },
  },
];

const Arrow = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M7 17 17 7M8 7h9v9" />
  </svg>
);

const Developments = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="sv-page dv-page">
      <Seo {...SEO} />

      <header className="sv-hero">
        <div className="sv-shell">
          <span className="sv-eyebrow">Developments</span>
          <h1 className="sv-title">Things we&rsquo;ve built.</h1>
          <p className="sv-intro">
            Products we design, build and run ourselves, from AI platforms to learning apps.
            Each one is live, in use, and maintained in-house.
          </p>
        </div>
      </header>

      <section className="dv-list">
        <div className="sv-shell">
          {projects.map((p, i) => (
            <article key={p.name} className={`dv-project${i % 2 ? ' dv-project--flip' : ''}`}>
              <div className={`dv-media dv-media--${p.image}`}>
                <picture>
                  <source srcSet={assetUrl(`/images/${p.image}.webp`)} type="image/webp" />
                  <img src={assetUrl(`/images/${p.image}.jpg`)} alt={p.alt} loading={i ? 'lazy' : 'eager'} decoding="async" />
                </picture>
              </div>

              <div className="dv-body">
                <span className="dv-idx">{String(i + 1).padStart(2, '0')}</span>
                <h2 className="sv-h2">{p.name}</h2>
                <p className="dv-kind">{p.kind}</p>
                <p className="sv-lead">{p.desc}</p>
                <a className="dv-link" href={p.link.href} target="_blank" rel="noopener noreferrer">
                  {p.link.label} <Arrow />
                </a>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="sv-cta">
        <div className="sv-shell">
          <h2 className="sv-h2">Have something in mind?</h2>
          <a className="lp-btn lp-btn-primary" href="mailto:info@tavernix.io">info@tavernix.io</a>
        </div>
      </section>

      <footer className="lp-footer">
        <div className="lp-shell lp-footer-inner">
          <span>&copy; 2026 Tavernix Systems // Est_2024</span>
          <a href="mailto:info@tavernix.io">info@tavernix.io</a>
        </div>
      </footer>
    </div>
  );
};

export default Developments;
